import {
    POP_NOTIFICATION,
    PUSH_NOTIFICATION,
    REMOVE_NOTIFICATION,
    SET_NOTIFICATION_TIMEOUT
} from "../constants/mutations";

const state = {
    queue: [],
    TIMEOUT: 2 * 100000, // 2 second
};

const getters = {
    queue: (state) => state.queue,
    TIMEOUT: (state) => state.TIMEOUT,
};

const actions = {
    notify({ state, commit }, { message, color = 'info' }) {
        commit(PUSH_NOTIFICATION, { message, color });
        setTimeout(() => {
            commit(POP_NOTIFICATION);
        }, state.TIMEOUT);
    },
    dismiss({ commit }, index) {
        commit(REMOVE_NOTIFICATION, index);
    },
};

const mutations = {
    [PUSH_NOTIFICATION](state, payload) {
        state.queue.push(payload);
    },
    [POP_NOTIFICATION](state, _) {
        state.queue.shift();
    },
    [REMOVE_NOTIFICATION](state, index) {
        state.queue = state.queue.filter((value, i) => i !== index);
    },
    [SET_NOTIFICATION_TIMEOUT](state, payload) {
        state.TIMEOUT = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
